module.exports = __webpack_public_path__ + "static/intellect_devourer-6a6a063abc7aa787156aa558b12a27f7.jpeg";